import * as Redux from 'redux'
import * as IsActive from '../../components/is_active'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const initialDataState: Types.ComponentDataState = {
  communityPoolList: {},
  ipPoolList: {},
}

const initialViewState: Types.ComponentViewState = {
  ipDropDown: false,
  isLoading: false,
  selectedDisplay: Constants.DISPLAY_NAME,
}

type AllActions = Redux.Action &
      Request.SuccessAction

const dataReducer = (state: Types.ComponentDataState = initialDataState, action: AllActions) => {
  switch (action.type) {
  case Request.successConstant(Constants.FETCH_POOLS):
    return {
      ...state,
      ipPoolList: Utils.getIpPools(action.payload.response),
    }
  case Request.successConstant(Constants.POOLS_FETCH_COMMUNITIES):
    return {
      ...state,
      communityPoolList: Utils.getCommunityPools(action.payload.response),
    }
  default:
    return state
  }
}

const viewReducer = (
  state: Types.ComponentViewState = initialViewState,
  action: Redux.Action & IsActive.FilterActionObject,
) => {
  switch (action.type) {
    case IsActive.filterStatusConstant(Constants.TOGGLE_DISPLAY_NAME):
      return {
        ...state,
        selectedDisplay: action.filter,
      }
    case Request.requestConstant(Constants.FETCH_POOLS):
    case Request.requestConstant(Constants.POOLS_FETCH_COMMUNITIES):
        return {
        ...state,
        isLoading: true,
      }
    case Request.successConstant(Constants.POOLS_FETCH_COMMUNITIES):
      return {
        ...state,
        isLoading: false,
      }
    default:
      return state || initialViewState
  }
}

export const reducer = Redux.combineReducers({
  data: dataReducer,
  view: viewReducer,
})



// WEBPACK FOOTER //
// ./src/pages/ip-pools/reducer.tsx